import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { ExtraBase } from '~/lib/api/smartsend/types';
import { ToUniqueExtrasList } from '~/apps/smartsend/lib/helpers/ToUniqueExtras';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  extras: ExtraBase[];
  edit: () => void;
  revealText?: string;
  variant?: 'body2';
}

export function ItemExtrasMobile(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GGrid container gap={1} alignItems="center" wrap="nowrap">
      <P2GGrid item flexGrow={1}>
        <P2GText variant={props.variant}>
          {ToUniqueExtrasList(t, props.extras) || t('SERVICE_EXTRAS', 'Service extras and protection')}
        </P2GText>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        <P2GLink variant={props.variant} onClick={props.edit}>
          {props.revealText || t('ADD_LINK', 'Add')}
        </P2GLink>
      </P2GGrid>
    </P2GGrid>
  );
}
